import script from "./RecentReports.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecentReports.vue?vue&type=script&setup=true&lang=ts"

import "./RecentReports.vue?vue&type=style&index=0&id=46eb04f1&lang=scss"

const __exports__ = script;

export default __exports__